export class HttpHelper {

    static get(url, queryParams = []) {

        return axios.get(url, {params:queryParams})
            .then(response => {
                return response.data;
            });
    }

    static post(url, params = []) {

        return axios.post(url, params)
            .then(response => {
                return response.data;
            });
    }
}